import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../../components/PageHero';
import { IconTarget, IconEye, IconCheckCircle } from '../../components/Icons';
import './Nosotros.css';

export default function MisionVision() {
  return (
    <div>
      <PageHero
        label="Nosotros"
        title="Misión y Visión"
        subtitle="Los pilares estratégicos que guían el rumbo y el propósito de Impacta M.A. SAS."
        variant="blue"
      />

      <section className="section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card mv-card--mission anim-fade-up">
              <div className="mv-card__header">
                <div className="mv-card__icon-wrap mv-card__icon-wrap--green">
                  <IconTarget size={26} />
                </div>
                <h2>Misión</h2>
              </div>
              <p>
                Brindar soluciones técnicas especializadas en consultoría minera y ambiental, contribuyendo al desarrollo sostenible del sector extractivo colombiano mediante el cumplimiento estricto de la normatividad vigente, el cuidado del entorno natural y la protección de la vida de los trabajadores.
              </p>
              <div className="mv-card__pillars">
                <h4>Pilares de nuestra misión</h4>
                <ul>
                  {['Seguridad de los trabajadores', 'Cumplimiento normativo', 'Cuidado ambiental', 'Excelencia técnica'].map(p => (
                    <li key={p}>
                      <IconCheckCircle size={16} className="mv-check-icon mv-check-icon--green" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mv-card mv-card--vision anim-fade-up anim-delay-2">
              <div className="mv-card__header">
                <div className="mv-card__icon-wrap mv-card__icon-wrap--blue">
                  <IconEye size={26} />
                </div>
                <h2>Visión</h2>
              </div>
              <p>
                Para el año 2030, ser reconocidos como la empresa líder en consultoría minera y ambiental en la región andina colombiana, distinguida por la calidad técnica de sus entregables, la confianza de sus clientes y su contribución a la minería responsable con el entorno y las comunidades.
              </p>
              <div className="mv-card__pillars">
                <h4>Metas estratégicas 2030</h4>
                <ul>
                  {['Liderazgo regional', 'Calidad técnica certificada', 'Confianza del cliente', 'Minería responsable'].map(p => (
                    <li key={p}>
                      <IconCheckCircle size={16} className="mv-check-icon mv-check-icon--blue" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--bg">
        <div className="container" style={{textAlign:'center'}}>
          <div className="divider divider--center" />
          <h2 className="section-title">¿Quiere conocer más sobre nosotros?</h2>
          <p className="section-lead section-lead--center" style={{marginBottom:'32px'}}>
            Explore nuestros valores corporativos y cómo trabajamos para usted.
          </p>
          <div style={{display:'flex',gap:'16px',justifyContent:'center',flexWrap:'wrap'}}>
            <Link to="/nosotros/valores" className="btn btn--primary btn--lg">Valores corporativos</Link>
            <Link to="/contacto" className="btn btn--outline btn--lg">Contáctenos</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
